import { jsx as _jsx } from "react/jsx-runtime";
/**
 * BackorderChip - pill badge for products in backorder state.
 *
 * Design: amber pill matching brand gold palette.
 * Animation: opacity 0→1 + translateY(-2px→0) on mount, 220ms ease-out.
 * Motion rules (emil-design-eng):
 *   - Entry: ease-out, 220ms, NO scale(0), NO ease-in.
 *   - reducedMotion: opacity-only.
 *   - uses transform: translate3d NOT Framer Motion y prop (hardware-accelerated).
 */
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { usePrefersReducedMotion } from '@/components/animations';
// ─── Constants ────────────────────────────────────────────────────────────────
const EASE_OUT = [0.22, 1, 0.36, 1];
// ─── Component ────────────────────────────────────────────────────────────────
export function BackorderChip({ compact = false }) {
    const { t } = useTranslation('products');
    const reduced = usePrefersReducedMotion();
    const initial = reduced
        ? { opacity: 0 }
        : { opacity: 0, transform: 'translate3d(0, -2px, 0)' };
    const animate = reduced
        ? { opacity: 1 }
        : { opacity: 1, transform: 'translate3d(0, 0px, 0)' };
    return (_jsx(motion.span, { initial: initial, animate: animate, transition: { duration: 0.22, ease: EASE_OUT }, className: [
            'inline-flex items-center rounded-full border border-gold-300 bg-cream-100 font-medium uppercase tracking-wide text-gold-700',
            compact ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-0.5 text-xs',
        ].join(' '), "aria-label": t('stock.backorder.chip'), children: t('stock.backorder.chip') }));
}
